import { QueryObserver } from '@tanstack/query-core';

import { fetchFinancialConfig } from '../../predict/src/core/api/financial-config';
import { queryClient } from '../core/queryClient';

export type FetchFinancialConfigResult = Awaited<ReturnType<typeof fetchFinancialConfig>>;

export const financialConfigQueryKey = (workspaceId: string, organisationId: string) => [
  'financial-config',
  workspaceId,
  organisationId
];

export const financialConfigQuery = (
  workspaceId: string,
  organisationId: string
): QueryObserver<FetchFinancialConfigResult> =>
  new QueryObserver<FetchFinancialConfigResult>(queryClient, {
    queryKey: financialConfigQueryKey(workspaceId, organisationId),
    queryFn: () => fetchFinancialConfig(workspaceId, organisationId)
  });
